import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material";

const Connector = styled(StepConnector)(({ theme }) => {
    const { palette } = theme;
    const { dark, secondary } = palette;

    return {
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 22,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor: dark.main,
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor: dark.main,
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 3,
            border: 0,
            borderRadius: 1,
            backgroundColor: secondary.light,
        },
    };
});

export default Connector;
